import React from 'react'
import PolicyTab from './PolicyTab'

function PolicyView() {
  return (
    <div>
      <PolicyTab />  
    </div>
  )
}

export default PolicyView
